export const BaseAPIUrl = process.env.REACT_APP_SECURITY_URL;

export const httpFetch = (url, config) => {
  return fetch(BaseAPIUrl + url, config)
    .then((res) => res.json())
    .catch((err) => err);
};
